module.exports = __webpack_public_path__ + "img/4.c8332a07.jpg";